import React, { useContext, useEffect, useRef, useState } from "react";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";

const translations = {
  en: {
    selectLanguage: "Select Language:",
    victimTitle: "Basic information of the victim",
    victimNote: "Answer the set of questions about the victim.",
    continue: "Continue",
  },
  Hi: {
    selectLanguage: "भाषा चुनें:",
    victimTitle: "पीड़ित की बुनियादी जानकारी",
    victimNote: "पीड़ित के बारे में प्रश्नों का उत्तर दें।",
    continue: "जारी रखें",
  },
  Kn: {
    selectLanguage: "ಭಾಷೆ ಆಯ್ಕೆ ಮಾಡಿ:",
    victimTitle: "ಹಣ ಕಳೆದುಕೊಂಡ ವ್ಯಕ್ತಿಯ ಮಾಹಿತಿ",
    victimNote: "ವಂಚನೆಗೊಳಗಾದ ವ್ಯಕ್ತಿಯ ಬಗೆಗಿನ ಈ ಕೆಳಕಂಡ ವಿವರಗಳನ್ನು ನಮೂದಿಸುವುದು.",
    continue: "ಮುಂದುವರಿಸಿ",
  },
};

const Victim = ({ onNext, onQuestion,selectedLang }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);
  const audioMap = {
    en: "audio/English BOT Audios/victim.mp3",
    Hi: "audio/Hindi BOT Audios/Hindi-Audio7.mp3",
    Kn: "audio/Kannada BOT Audios/Kannada-Audio7.m4a",
    tcy: "audio/cybervictim_tcy.mp3"
  };
  const handleOkClick = (e) => {
    e.preventDefault();
    if (audioRef.current && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
    onNext(6);
    onQuestion(7);
    localStorage.setItem("victim", JSON.stringify("victim"));
  };

  
      useEffect(() => {
        if (audioRef.current) {
          // Update the audio source and reload the element
          audioRef.current.src = audioMap[selectedLang] || audioMap["en"];
          audioRef.current.load();
          // If audio was playing, continue playing the new audio
          if (isPlaying) {
            audioRef.current.play();
          }
        }
      }, [selectedLang, isPlaying]);

           useEffect(() => {
               const handler = () => {
                if (audioRef.current) {
                   audioRef.current.pause();
                   audioRef.current.currentTime = 0;
                    setIsPlaying(false);
                  }
                };
                window.addEventListener('pauseAllAudio', handler);
                return () => window.removeEventListener('pauseAllAudio', handler);
              }, []);

  const toggleAudio = (e) => {
    e.preventDefault();
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false);
  };

  return (
    <div className="question">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <h2>{translations[selectedLang].victimTitle}</h2>
            <button onClick={toggleAudio} className="audio-button">
              {isPlaying ? <FaPause color="White" size={12} style={{ marginBottom: '20px' }}/> : <FaPlay color="White" size={12} style={{ marginBottom: '20px' }}/>}
            </button>
          </div>
          <audio ref={audioRef} onEnded={handleAudioEnd}>
            <source src={audioMap[selectedLang]} type="audio/mp3" />
            Your browser does not support the audio element.
          </audio>
          <p className="victim-para">{translations[selectedLang].victimNote}</p>
          <div style={{ display: "flex", alignItems: "center" }}>
            <button type="button" className="continue-btn" onClick={handleOkClick}>
              {translations[selectedLang].continue}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Victim;
